module.exports = __webpack_public_path__ + "201811/img/top_23.1ec97b84.png";